<template>
  <div>
    <div class="panel-header">
      <span class="panel-bar"></span>
      <span class="panel-title">用户协议</span>
    </div>

    <div class="placeholder">
      <!-- 这里放你的简历编辑/展示组件（可用 el-form / el-descriptions / 自定义卡片） -->
    </div>
  </div>
</template>

<script setup>
//   defineEmits(['edit', 'update-profile'])
</script>

<style scoped>
.panel-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 22px;
}
.panel-bar {
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #4caf50;
}
.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #2b2f33;
}
.placeholder {
  padding-left: 22px;
  color: #8a8f98;
  font-size: 13px;
}
</style>